import { useEffect } from 'react';
import { LexicalEditor } from 'lexical';
import { $getRoot } from 'lexical';

interface UseEditorStateSyncProps {
  editor: LexicalEditor;
  editorStateRef: React.MutableRefObject<any>;
  textLengthRef: React.MutableRefObject<number>;
  onChange?: () => void;
}

export const useEditorStateSync = ({
  editor,
  editorStateRef,
  textLengthRef,
  onChange
}: UseEditorStateSyncProps) => {
  useEffect(() => {
    const unsubscribe = editor.registerUpdateListener(
      ({ editorState, dirtyElements, dirtyLeaves }) => {
        editorStateRef.current = editorState.toJSON();

        editorState.read(() => {
          const plainText = $getRoot().getTextContent();
          textLengthRef.current = plainText.length;
        });

        if ((dirtyElements && dirtyElements.size > 0) || (dirtyLeaves && dirtyLeaves.size > 0)) {
          onChange && onChange();
        }
      }
    );

    return unsubscribe;
  }, [editor, editorStateRef, textLengthRef, onChange]);

  // Additional sync for serialized state
  useEffect(() => {
    const unsubscribe = editor.registerUpdateListener(({ editorState }) => {
      const serializedState = editorState.toJSON();
      editorStateRef.current = serializedState;
    });

    return unsubscribe;
  }, [editor, editorStateRef]);
}; 